import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import TaskComment from './task_comment';
import TaskThreadEmailCard from './task_thread_emails';

export default function TaskThread({ className, thread, canRedactComment, selectedComment, inItemDisplay }) {
  if (!thread || !thread.length) return null;

  return (
    <div className={className} data-aid="taskThread">
      {thread.map(entry => {
        if (entry.kind === 'email') {
          return (
            <StyledThreadEmail
              $inItemDisplay={inItemDisplay}
              email={entry.email}
              inItemDisplay={inItemDisplay}
              key={entry.id}
            />
          );
        }
        return (
          <StyledThreadComment
            {...entry.comment}
            $inItemDisplay={inItemDisplay}
            canRedactComment={canRedactComment && !entry.comment.isRedacted}
            key={entry.id}
            selectedAt={selectedComment && entry.comment.id === selectedComment.id ? selectedComment.at : undefined}
          />
        );
      })}
    </div>
  );
}

TaskThread.propTypes = {
  className: PropTypes.string,
  thread: PropTypes.array,
  canRedactComment: PropTypes.bool,
  selectedComment: PropTypes.object,
  inItemDisplay: PropTypes.bool,
};

// Match StyledComment's 16px horizontal padding so email cards line up with comments.
const StyledThreadEmail = styled(TaskThreadEmailCard)`
  margin-bottom: 12px;
  margin-top: 12px;
  ${p => !p.$inItemDisplay && 'margin-left: 16px; margin-right: 16px;'}
`;

const StyledThreadComment = styled(TaskComment)`
  ${p => p.$inItemDisplay && 'padding-left: 0; padding-right: 0;'}
`;
